<ul class="app-user-menu-items" nz-menu [nzMode]="'inline'" [nzSelectable]="false">
  @if (userVerified$ | async) {
  <li class="app-user-menu-item" class="d-flex d-sm-none" nz-menu-item (click)="settings()">
    <app-image [name]="'account'"></app-image>
    <span translate>menu.user.settings</span>
  </li>
  <li class="d-none d-sm-flex" nz-menu-item (click)="profileInformation()" data-cy="user-menu-item-settings">
    <app-image [name]="'account'"></app-image>
    <span translate>menu.user.settings</span>
  </li>
  @if (referralEnabled) {
  <li nz-menu-item (click)="invite()">
    <app-image [name]="'invite'"></app-image>
    <span translate>menu.user.invite</span>
  </li>
  } } @if (displayVerification$ | async) {
  <li nz-menu-item (click)="goToVerification()">
    <app-image [name]="'verification'"></app-image>
    <span translate>menu.user.verification</span>
  </li>
  } @if (helpEnabled) {
  <li nz-menu-item (click)="help()">
    <app-image [name]="'help'"></app-image>
    <span translate>menu.user.help</span>
  </li>
  }
  <ng-container>
    @if ((displaySwitchProfile$ | async) || (openBusinessAccountEnabled$ | async)) {
    <hr />
    } @if (displaySwitchProfile$ | async) {
    <li nz-menu-item (click)="switch()">
      <app-image [name]="'switch'"></app-image>
      <span translate>menu.user.switch</span>
    </li>
    } @if (openBusinessAccountEnabled$ | async) {
    <li nz-menu-item (click)="businessAccount()">
      <app-image [name]="'businessacc'"></app-image>
      <span translate>menu.user.businessAccount</span>
    </li>
    } @if (openPersonalAccountEnabled$ | async) {
    <li nz-menu-item (click)="openPersonalAccount()">
      <app-image [name]="'personalacc'"></app-image>
      <span translate>menu.user.personalAccount</span>
    </li>
    } @if ((userVerified$ | async) || (displayVerification$ | async)) {
    <hr />
    }
  </ng-container>
  <li nz-menu-item (click)="logout()" data-cy="user-menu-item-logout">
    <app-image [name]="'logout'"></app-image>
    <span translate>menu.user.logout</span>
  </li>
</ul>
